module.exports = __webpack_public_path__ + "img/debit.0c894c5a.png";